<template>
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="link_backwards" transform="translate(-6.000000, -10.000000)" fill="currentColor">
        <g id="Actions-/-Navigation-/-close-/-24" transform="translate(0.000000, 4.000000)">
          <polygon
            id="Fill"
            points="18 7.05 16.95 6 12 10.95 7.05 6 6 7.05 10.95 12 6 16.95 7.05 18 12 13.05 16.95 18 18 16.95 13.05 12"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Close'
};
</script>
